<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"

    >
        <retencion-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>

    import RetencionProvider from "../../../../providers/RetencionProvider";

    import {CrudCreate, ClientError} from '@dracul/common-frontend'

    import RetencionForm from "../RetencionForm";




    export default {
        name: "RetencionCreate",

        components: { RetencionForm, CrudCreate },

        props:{
          open: {type: Boolean, default: true}
        },

        data() {
            return {
                title: 'cobrox.retencion.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    archivo: null,
                }
            }
        },

        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    RetencionProvider.createRetencion(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createRetencion)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

